// extracted by mini-css-extract-plugin
export default {"servicesMenuPage":"services-menu-page_servicesMenuPage__+cbD1","sectionGrid":"services-menu-page_sectionGrid__u0-kH"};